// Phase 11 · Step 3: the agreement's light Markdown, parsed once for the portal, the dashboard preview and the PDF.
// Supports: "# title", "## heading", "- bullet", "| table | rows |", paragraphs, **bold** and *italic*.
// Pure JS, no imports.

const unescape = s => String(s).replace(/\\([\\[\]$*_|#-])/g, "$1");

/** "**Lead.** text *aside*" → [{ text, bold, italic }] */
export function inline(text) {
  const out = [];
  const re = /(\*\*([^*]+)\*\*|\*([^*\s][^*]*)\*|(?:^|(?<=\s))_([^_\s][^_]*)_(?=\s|$|[.,;:]))/g;
  let last = 0, m;
  const src = String(text || "");
  while ((m = re.exec(src))) {
    if (m.index > last) out.push({ text: unescape(src.slice(last, m.index)) });
    if (m[2] != null) out.push({ text: unescape(m[2]), bold: true });
    else out.push({ text: unescape(m[3] != null ? m[3] : m[4]), italic: true });
    last = m.index + m[0].length;
  }
  if (last < src.length) out.push({ text: unescape(src.slice(last)) });
  return out.filter(x => x.text);
}

const cells = line => {
  const t = line.trim().replace(/^\|/, "").replace(/\|$/, "");
  const out = []; let cur = "", esc = false;
  for (const ch of t) {
    if (esc) { cur += ch; esc = false; continue; }
    if (ch === "\\") { cur += ch; esc = true; continue; }
    if (ch === "|") { out.push(cur.trim()); cur = ""; continue; }
    cur += ch;
  }
  out.push(cur.trim());
  return out;
};
const isSeparator = line => /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/.test(line);

/**
 * Text → blocks:
 *   { type: "title" | "heading", spans }
 *   { type: "p", spans }   { type: "bullet", spans }   { type: "gap" }
 *   { type: "table", head: [spans[]], rows: [[spans[]]] }
 */
export function parseAgreement(text) {
  const lines = String(text || "").replace(/\r\n?/g, "\n").split("\n");
  const blocks = [];
  for (let i = 0; i < lines.length; i++) {
    const raw = lines[i], t = raw.trim();
    if (!t) { if (blocks.length && blocks[blocks.length - 1].type !== "gap") blocks.push({ type: "gap" }); continue; }
    if (t.startsWith("|")) {
      const rowsRaw = [];
      while (i < lines.length && lines[i].trim().startsWith("|")) { rowsRaw.push(lines[i]); i++; }
      i--;
      const body = rowsRaw.filter(l => !isSeparator(l)).map(cells);
      const hasHead = rowsRaw.length > 1 && isSeparator(rowsRaw[1]);
      const head = hasHead ? body.shift() : null;
      blocks.push({ type: "table", head: head ? head.map(inline) : null, rows: body.map(r => r.map(inline)) });
      continue;
    }
    const h = /^(#{1,6})\s+(.*)$/.exec(t);
    if (h) { blocks.push({ type: h[1].length === 1 ? "title" : "heading", spans: inline(h[2].replace(/\*\*/g, "")) }); continue; }
    if (/^\*\*[^*]+\*\*:?$/.test(t)) { blocks.push({ type: "heading", spans: inline(t.replace(/\*\*/g, "")), lead: true }); continue; }
    const b = /^[-*•]\s+(.*)$/.exec(t);
    if (b) { blocks.push({ type: "bullet", spans: inline(b[1]) }); continue; }
    blocks.push({ type: "p", spans: inline(t) });
  }
  while (blocks.length && blocks[blocks.length - 1].type === "gap") blocks.pop();
  return blocks;
}

export const spansText = spans => (spans || []).map(s => s.text).join("");
